export default "__VITE_ASSET__DXsWDShb__"